import { render, staticRenderFns } from "./SlideCard.vue?vue&type=template&id=3cd6ee16"
import script from "./SlideCard.vue?vue&type=script&lang=js"
export * from "./SlideCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports